import {Dropdown, Option} from "@fluentui/react-components";
import {BusinessUnit} from "../../types/types";
import React from "react";

export type BusinessUnitDropdownValue = BusinessUnit | 'ALL';

interface BusinessUnitDropdownProps {
    value: BusinessUnitDropdownValue;
    onChange: (value: BusinessUnitDropdownValue) => void;
}

const LABELS: Record<BusinessUnitDropdownValue, string> = {
    ALL: 'All',
    DCTS: 'DCTS',
    JOBS: 'Jobs',
    HOME_MAID: 'Home Maid',
}

export default function BusinessUnitDropdown(props: Readonly<BusinessUnitDropdownProps>) {
    return (
        <Dropdown
            style={{width: '100%'}}
            value={LABELS[props.value]}
            selectedOptions={[props.value]}
            onOptionSelect={(_, data) => props.onChange(data.optionValue as BusinessUnitDropdownValue)}
        >
            {(['ALL', 'DCTS', 'HOME_MAID', 'JOBS'] as BusinessUnitDropdownValue[]).map(unit => (
                <Option key={unit} value={unit}>{LABELS[unit]}</Option>
            ))}
        </Dropdown>
    );
}